<template>
  <main v-if="isCmsPreview" class="cms-preview-error" role="alert">
    <h1>{{ copy.title }}</h1>
    <p>{{ copy.description }}</p>
    <small>{{ status }}</small>
  </main>
  <DefaultError v-else :error="error" />
</template>
<script setup>
import DefaultError from '#cms-default-error';
const props = defineProps({error: {type: Object, required: true}});
const config = useAppConfig();
const isCmsPreview = computed(() => {
  let data = props.error.data;
  if (typeof data === 'string') {
    try { data = JSON.parse(data); } catch { return false; }
  }
  return data?.cmsStaticContentPreview === true;
});
const status = computed(() => Number(props.error.statusCode) || 500);
const copy = computed(() => config.lang === 'si'
  ? {title: 'Predogled CMS ni na voljo.', description: 'Vrnite se v urejevalnik, preverite URL strani in odprite nov predogled. Vaš vnos je ohranjen v urejevalniku.'}
  : {title: 'CMS pregled nije dostupan.', description: 'Vratite se u editor, provjerite URL stranice i otvorite novi pregled. Unos je sačuvan u editoru.'});
if (import.meta.server && isCmsPreview.value) setResponseStatus(useRequestEvent(), status.value);
</script>
<style scoped>
.cms-preview-error{max-width:36rem;margin:0 auto;padding:32px;font-family:inherit;color:#101117;background:#fff}
.cms-preview-error h1{font-size:24px;margin:0 0 16px}.cms-preview-error p{line-height:1.5;margin:0 0 16px}.cms-preview-error small{color:#545f71}
</style>
